var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarholLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 393,
    height: 45,
    viewBox: "0 0 393 45",
    className: "undefined",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-width:1;stroke:none;}.b{fill:#fff;}.c{fill:#808080;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1 12L25.5 12 25.5 20.2 18.1 20.2 18.1 32.4C18.1 35.1 18.8 36.6 21.8 36.6L25.5 36.6 25.5 43.7C22.7 44.4 19.8 44.7 17 44.7 9.9 44.7 4.9 42.7 4.9 36.2L4.9 20.2 0 20.2 0 12 5.4 12 8.3 2.2 18.1 2.2 18.1 12Z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 15.3C47 12.6 51 11.2 55 11.2 63.3 11.2 67.2 15.7 67.2 23.2L67.2 44 54 44 54 24.7C54 22 52.5 20.1 49.6 20.1 46.3 20.1 44.1 22.5 44.1 25.1L44.1 44 30.9 44 30.9 0 44 0 44 15.3Z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8 28L110.8 30 84.6 30C84.6 34.4 86.6 37 91.6 37 96.3 37 98 34.9 98 32.3L110.8 32.3C110.8 40 104.4 44.7 91.9 44.7 79.3 44.7 71.4 39.5 71.4 28 71.4 16.8 79.2 11.3 91.1 11.3 103.6 11.2 110.8 16.4 110.8 28ZM84.7 24.3L97.5 24.3C97.5 21 95.3 18.9 91.6 18.9 87.2 18.9 85.1 21 84.7 24.3Z",
    className: "b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.8 44 170 44 164.6 26.2 164.3 26.2 158.8 44 146 44 133.2 12 147.3 12 152.6 30.9 153.1 30.9 158.6 12 171.7 12 177 30.9 177.5 30.9 182.8 12 195.6 12",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.2 21.7L234.2 34.2C234.2 35.5 234.9 36.5 236.4 36.5L238.7 36.5 238.7 43.5C236.6 44.4 234.2 44.8 231.9 44.8 226.6 44.8 223.3 43.2 222.1 40.8 218.4 43.5 213.9 44.9 209.2 44.8 202 44.8 196.9 42.4 196.9 35.8 196.9 26.2 205.8 24.3 221.1 24.3L221.1 22.8C221.1 20.1 218.8 18.9 216 18.9 213.7 18.9 211 19.6 211 21.7L211 22 198 22C197.9 21.7 197.9 21.4 197.9 21.2 197.9 15.3 204.2 11.3 216.2 11.3 225.8 11.2 234.2 13.8 234.2 21.7ZM221.1 30C213.3 30 210.1 31.8 210.1 34.1 210.1 36.5 212.3 37.1 214.6 37.1 218 37.1 221.1 35.3 221.1 32.7L221.1 30Z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.8 11.9L267.8 22 263.6 22C257.9 22 255.9 24.9 255.9 29.7L255.9 44 242.7 44 242.7 12 253.5 12 254.3 16.9C256 13 259.8 11.2 263.9 11.2 265.3 11.2 266.6 11.4 267.8 11.9L267.8 11.9Z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9 15.3C289.9 12.6 293.8 11.2 297.8 11.2 306.1 11.2 310 15.7 310 23.2L310 44 296.8 44 296.8 24.7C296.8 22 295.3 20.1 292.4 20.1 289.1 20.1 286.9 22.5 286.9 25.1L286.9 44 273.7 44 273.7 0 286.9 0 286.9 15.3Z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.9 28C353.9 39.2 346.1 44.8 334.2 44.8 322.3 44.8 314.6 39.2 314.6 28 314.6 16.8 322.3 11.3 334.2 11.3 346.1 11.3 353.9 16.7 353.9 28ZM327.8 26.3L327.8 29.8C327.8 34 329.6 36.6 334.2 36.6 338.9 36.6 340.8 34 340.8 29.8L340.8 26.3C340.8 22 338.9 19.4 334.2 19.4 329.6 19.4 327.8 22 327.8 26.3L327.8 26.3Z",
    className: "b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.3 44 358.1 44 358.1 0 371.3 0",
    className: "b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.4,
    y: 14.4,
    width: 12.9,
    height: 11.2,
    className: "c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.4,
    y: 32.8,
    width: 12.9,
    height: 11.2,
    className: "c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarholLogo);
export default __webpack_public_path__ + "static/media/warhol-logo.e5f80b805950328f3781bcea79c7db1b.svg";
export { ForwardRef as ReactComponent };